export var chatMessageDetailsStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      color: v.detailsColor,
      display: 'inline-block',
      fontSize: v.detailsFontSize
    }, p.density === 'comfy' && Object.assign({}, (p.attached === 'top' || !p.attached || p.hasHeaderReactionGroup) && {
      marginLeft: v.detailsMargin
    }), p.density === 'compact' && {
      alignSelf: 'flex-start',
      flexShrink: 0,
      marginLeft: v.detailsMargin
    });
  }
};